import type { IconData } from '../../types';

export const data: IconData = {
  o: '<path d="m174-483 169 170q12 12 11 28-1 15-13 28-12 12-28 12t-28-12L88-454q-6-6-9-13t-3-15q0-8 3-15t9-13l200-200q12-12 28-12 17 0 29 12 11 11 11 28t-11 29L174-483Zm613 2L617-651q-12-12-11-28 1-15 13-28 12-12 28-12t28 12l197 197q6 6 9 13t3 15q0 8-3 15t-9 13L672-254q-12 12-28 12t-28-13q-12-12-12-28t12-28l171-170Z"/>',
  f: '<path d="m174-483 169 170q12 12 11 28-1 15-13 28-12 12-28 12t-28-12L88-454q-6-6-9-13t-3-15q0-8 3-15t9-13l200-200q12-12 28-12 17 0 29 12 11 11 11 28t-11 29L174-483Zm613 2L617-651q-12-12-11-28 1-15 13-28 12-12 28-12t28 12l197 197q6 6 9 13t3 15q0 8-3 15t-9 13L672-254q-12 12-28 12t-28-13q-12-12-12-28t12-28l171-170Z"/>',
};

export default data;
